import { Pipe } from '@angular/core';
var EveryPipe = (function () {
    function EveryPipe() {
    }
    EveryPipe.prototype.transform = function (input, predicate) {
        return Array.isArray(input) ? input.every(predicate) : false;
    };
    EveryPipe.decorators = [
        { type: Pipe, args: [{ name: 'every' },] },
    ];
    /** @nocollapse */
    EveryPipe.ctorParameters = function () { return []; };
    return EveryPipe;
}());
export { EveryPipe };
//# sourceMappingURL=every.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/every.js
// module id = 221
// module chunks = 4